type Props = {
  value: number;
  max: number;
};

const ProgressBar = ({ value, max }: Props) => {
  const progress = Math.round((value / max) * 100);

  return (
    <div className="relative pt-1" style={{ width: "100px" }}>
      <div className="flex flex-col">
        <div className="h-2 w-full rounded-lg border border-gray-400 bg-white">
          <div className="h-full rounded-lg bg-green" style={{ width: `${progress}%`, transition: "width 0.3s" }} />
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
